import React, { useEffect } from "react";
import { useStateIfMounted } from "use-state-if-mounted";
import { RadialGauge } from "canvas-gauges";
import mqtt_topics from "./../../../mqtt/mqtt_topics";
import "./../../../css/app.css";
import useCheckMobileScreen from "./useCheckMobileScreen";

const Gauge = (props) => {
  let gaugeheightandwidth = useCheckMobileScreen() ? 65 : 150;
  const mac = mqtt_topics.choosenmac; //"0-5b-96";
  const [state, setState] = useStateIfMounted({
    value: 0,
    unit: props.unit,
    title: props.title,
    minValue: props.min,
    maxValue: props.max,
    limitover: 0, //300,
    limitunder: 0, //100,
    prelimitover: 0, //250,
    prelimitunder: 0, //150,
  });
  const target_live_reading_topic =
    mqtt_topics.fixed_topic_part +
    mac +
    "/" +
    props.category +
    mqtt_topics.Readings_topic +
    state.title;

  function listenforlivedata() {
    //console.log("target_live_reading_topic " + target_live_reading_topic);
    props.mqttClient.subscribe(target_live_reading_topic);
    props.mqttClient.on("message", handleMqttMessage);
  }

  function handleMqttMessage(topic, message) {
    if (topic == target_live_reading_topic) {
      try {
        // message is Buffer
        //console.log(topic, "From Surf Mode: " + message.toString());
        message = JSON.parse(message.toString());
        //console.log("value: " + message.value);
        setState({
          ...state,
          value: message.value == undefined ? 0 : message.value,
          maxValue: message.max == undefined ? state.maxValue : message.max,
          minValue: message.min == undefined ? state.minValue : message.min,
          limitover:
            message.limitover == undefined || message.limitover == "N"
              ? 0
              : message.limitover,
          limitunder:
            message.limitunder == undefined || message.limitunder == "N"
              ? 0
              : message.limitunder,
          prelimitover:
            message.prelimitover == undefined || message.prelimitover == "N"
              ? 0
              : message.prelimitover,
          prelimitunder:
            message.prelimitunder == undefined || message.prelimitunder == "N"
              ? 0
              : message.prelimitunder,
        });
      } catch (error) {
        //console.log("error " + message);
      }
    }
  }

  const calculatemajorTicks = (minValue, maxValue) => {
    const maxticksnumber = 6;
    let majorTicks = [];
    for (let i = 0; i < maxticksnumber; i++) {
      majorTicks[i] = Math.trunc(
        Math.round(
          (((+maxValue - +minValue) / (+maxticksnumber - 1)) * i + +minValue) *
            100
        ) / 100
      );
    }
    return majorTicks;
  };
  useEffect(() => {
    const redcolor = "rgba(200, 50, 50, .75)";
    const yellowcolor = "rgba(244, 155, 36, .75)";
    const blackcolor = "rgb(0,0,0)";
    const graycolor = "rgb(100,100,100)";
    if (document.getElementById(state.title + "_canvas") != null) {
      new RadialGauge({
        renderTo: state.title + "_canvas",
        value: state.value,
        width: gaugeheightandwidth,
        height: gaugeheightandwidth,
        //units: state.unit,
        minValue: state.minValue,
        maxValue: state.maxValue,
        majorTicks: calculatemajorTicks(state.minValue, state.maxValue),
        minorTicks: 3,
        strokeTicks: true,
        colorNeedle: blackcolor,
        colorNeedleEnd: blackcolor,
        highlights: [
          {
            from: state.minValue,
            to: state.limitunder != 0 ? state.limitunder : state.minValue,
            color: redcolor,
          },
          {
            from: state.limitover != 0 ? state.limitover : state.maxValue,
            to: state.maxValue,
            color: redcolor,
          },
          {
            from:
              state.prelimitunder != 0
                ? state.limitunder != 0
                  ? state.limitunder
                  : state.minValue
                : state.prelimitunder,
            to: state.prelimitunder,
            color: yellowcolor,
          },
          {
            from: state.prelimitover,
            to:
              state.prelimitover != 0
                ? state.limitover != 0
                  ? state.limitover
                  : state.maxValue
                : state.prelimitover,
            color: yellowcolor,
          },
        ],
        colorPlate: "#fff",
        borderShadowWidth: 0,
        borders: false,
        needleType: "arrow",
        //needlestart: 75,
        //needleend: 99,
        needleWidth: 1.5,
        needleCircleSize: 7,
        animationDuration: 1500,
        animationRule: "linear",
        colorValueBoxShadow: false,
        colorValueTextShadow: false,
        needleShadow: false,
        valueBox: false,
        //valueInt: 1,
        //valueDec: 1,
        fontValueSize: 30,
        fontValueWeight: "bold",
        colorValueText: "#000",
        colorValueBoxRect: "#fff",
        colorValueBoxRectEnd: "#fff",
        colorValueBoxBackground: "#fff",
        colorValueBoxShadow: false,
        colorValueTextShadow: false,
      }).draw();
    }
  }, [
    state.value,
    state.limitover,
    state.limitunder,
    state.prelimitover,
    state.prelimitunder,
    gaugeheightandwidth,
  ]);

  useEffect(() => {
    listenforlivedata();
  }, []);

  //when componenet unmount
  useEffect(
    () => () => {
      props.mqttClient.unsubscribe(target_live_reading_topic);
      props.mqttClient.removeListener("message", handleMqttMessage);
    },
    []
  );

  return (
    <div className="col">
      <div className="card text-center bg-light livecardsguages">
        <div className="card-header">{state.title}</div>
        <div className="card-body">
          <canvas id={state.title + "_canvas"}>
            <h5>Loading ...</h5>
          </canvas>
        </div>
        <div className="card-footer">
          <h5>
            {state.value + " "}
            <strong
              style={{ fontSize: useCheckMobileScreen() ? "8px" : "12px" }}
            >
              {state.unit}
            </strong>
          </h5>
        </div>
      </div>
    </div>
  );
};
export default Gauge;
